// Import all product data (legacy)
import tadreamkEye from "./tadreamk-eye.js";
import tadreamkCreate from "./tadreamk-create.js";
import tadreamkPatent from "./tadreamk-patent.js";
import tadreamkSurveillance from "./tadreamk-surveillance.js";
import trademarkTrading from "./trademark-trading.js";
import businessCardManager from "./business-card-manager.js";

// Import new config exports (migrated products)
import { tadreamkEyeConfig } from "./tadreamk-eye.js";
import { tadreamkCreateConfig } from "./tadreamk-create.js";

// Export all products as a single array (legacy)
export const DEFAULT_PRODUCTS = [
  tadreamkEye,
  tadreamkCreate,
  tadreamkPatent,
  tadreamkSurveillance,
  trademarkTrading,
  businessCardManager,
];

/**
 * Get product configuration by product ID
 * Used for new i18next-based product structure
 *
 * @param {string} productId - Product slug ID (e.g., 'tadreamk-eye')
 * @returns {Object|null} Product configuration with assets and icons
 */
export const getProductConfig = (productId) => {
  const configs = {
    "tadreamk-eye": tadreamkEyeConfig,
    "tadreamk-create": tadreamkCreateConfig,
    // Future migrated products will be added here
    // 'tadreamk-patent': tadreamkPatentConfig,
    // 'tadreamk-surveillance': tadreamkSurveillanceConfig,
  };

  return configs[productId] || null;
};

export default DEFAULT_PRODUCTS;
